import React from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box, IconButton } from '@mui/material';

const ProjectHistoryAttachment = ({ data }) => {
  const handleDownload = () => {
    if (data instanceof File) {
      const url = URL.createObjectURL(data);
      const link = document.createElement('a');
      link.href = url;
      link.download = data.fileName || 'download';
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
      return;
    } else if (data.path) {
      const url = `${process.env.REACT_APP_API_URL}/${data.path}`;
      window.open(url, '_blank');
    }
  };

  return (
    <Box display="flex" justifyContent="center">
      <IconButton onClick={() => handleDownload()}>
        {data.extension === '.pdf' ? <VisibilityIcon /> : <DownloadIcon />}{' '}
      </IconButton>
    </Box>
  );
};

export default ProjectHistoryAttachment;
